import { twc } from "../utils";

export const Typography = {
  GreetingLabel: twc.p`text-2xl font-medium text-accent tracking-tight`,
  GreetingHeading: twc.h1`text-size-greeting-heading leading-9 tracking-tighter`,
  GreetingSubheading: twc.p`text-size-agent font-medium text-text-agent`,
  Question: twc.h1`text-size-question text-text-question`,
  AgentText: twc.p`text-text-agent text-size-agent`,
  UserText: twc.div`text-text-user text-size-user font-medium`,
  Body: twc.p`text-base text-text`,
  Hint: twc.p`text-sm text-text-secondary`,
  Label: twc.p`text-xs font-medium text-text-secondary uppercase tracking-wide`,
  LabelH4: twc.h4`text-xs font-medium text-text-secondary uppercase tracking-wide`,
} as const;
